/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.6.28",
    versionName: "0.4.0-nightly.2026.6.28",
    versionChannel: "nightly",
    buildDate: "2026-06-28T00:35:19.782Z",
    commitHash: "1444ff43504649b8319afd305d6a8d0212d5a0fd",
};
